﻿{
  "community": {
    "name": "Yhteisö",
    "titles": {
      "1": "Verkkoyhteisö",
      "2": "Löydä materiaaleja",
      "3": "Jaa, mitä olet luonut"
    },
    "body": {
      "1": "Erinomainen paikka sukeltaa sisään ja tarkistaa kaikki, mitä Boardmaker tarjoaa",
      "2": "Näe mitä muut luovat ja jakavat. Kyseessä on ikään kuin ikkuna Boardmakerin taikuuteen!",
      "3": "Käyttäessäsi haluamaasi Boardmaker-ohjelmistoa, lataa ja jaa, mitä olet luonut yhteisön kanssa"
    }
  },
  "personal": {
    "name": "Henk.koht.",
    "header": "Sisältää kaiken Community-sisällön, sekä:",
    "titles": {
      "1": "Luo, muokkaa, toista ja tulosta",
      "2": "Boardmaker-ohjelmisto"
    },
    "body": {
      "1": "Vanhemmalle tai hoitajalle, jolla on yksi lapsi, halu luoda, muokata, toistaa ja tulostaa aktiviteetteja",
      "2": "Tilit tulevat Boardmaker 7 -lisenssillä, joka voidaan asentaa kahdelle Windows-tietokoneelle"
    }
  },
  "professional": {
    "name": "Ammatillinen",
    "header": "Sisältää kaiken Personal-sisällön, sekä:",
    "titles": {
      "1": "Opiskelijoiden hallinta",
      "2": "Yksilölliset asetukset"
    },
    "body": {
      "1": "Ohjaajille, joilla on 1 - 50 opiskelijaa, jotka haluavat jakaa tehtäviä ja jäljittää opiskelijatietoja",
      "2": "Mukautetut pääsyn asetukset yksittäisiä opiskelijoita varten"
    }
  },
  "organization": {
    "name": "Organisaatio",
    "header": "Sisältää kaiken Professional-sisällön, sekä:",
    "titles": {
      "1": "Monialaisen tiimituen"
    },
    "body": {
      "1": "Volyymihinnoittelu, organisaatio hallitsee tietoja ja useat henkilöt voivat määrittää samoja opiskelijoita"
    }
  }
}
